import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Lightbulb } from "lucide-react";

const TravelTips = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-yellow-50 to-orange-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-gradient-to-r from-yellow-400 to-orange-500 flex items-center justify-center shadow-lg">
              <Lightbulb className="w-10 h-10 text-white" />
            </div>
          </div>

          <h2 className="text-4xl font-bold text-gray-800 mb-6 bg-gradient-to-r from-yellow-600 to-orange-600 bg-clip-text text-transparent">
            Conoce nuestros mejores consejos para tu viaje
          </h2>

          <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto">
            Descubre tips exclusivos que harán que tu experiencia en Disney y
            Universal sea más mágica y sencilla. Desde qué llevar en tu maleta
            hasta cómo evitar largas filas.
          </p>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <Link
              to="/Tips"
              className="inline-block bg-gradient-to-r from-yellow-500 to-orange-600 text-white px-10 py-4 rounded-full text-lg font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              Ir a nuestros mejores tips →
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default TravelTips;
